export default "__VITE_ASSET__BXtq5i$k__"